import { api } from '../api'

interface RemoveWorkerPayload {
  propagate: boolean // if true, remove worker from the passed in shiftID and all shifts after it
  replace: boolean // if true, leave the spot unfilled. If false, reduce the number of workers by 1
  reason: string
  reason_category: string
  should_notify: boolean
}

export const removeWorker = async (
  companyId: number,
  assignmentId: number,
  workerId: number,
  shiftId: number,
  payload: RemoveWorkerPayload
) => {
  const response = await api.delete(
    `/company/${companyId}/assignment/${assignmentId}/worker/${workerId}/shift/${shiftId}`,
    { data: payload }
  )
  return response.data
}
